import styled from 'styled-components';
import { Button, theme } from 'components';

export const StyledContainer = styled.div<{
  md?: boolean;
  xl?: boolean;
  number?: number;
}>`
  display: grid;
  grid-gap: 15px;
  width: 100%;
  margin-top: 25px;
  padding-bottom: 20px;
  ${props => `
    padding-right: ${props.xl ? `10%` : 'inherit'};
    ${
      props.md
        ? `grid-template-columns: repeat(3, 1fr);`
        : `grid-template-rows: repeat(${Math.min(3, props.number)}, 1fr);`
    }
  `}
`;

export const StyledGrid = styled.div<{
  $breakpoints: Record<'md' | 'lg', boolean>;
}>`
  display: grid;

  ${({ $breakpoints: { md, lg } }) => {
    let columns = 3;
    if (!lg) columns = 2;
    if (!md) columns = 1;
    return `grid-template-columns: repeat(${columns}, 1fr);`;
  }}

  gap: 25px;
  max-width: 100%;
  align-items: flex-end;
`;

export const StyledSetting = styled.div<{
  alignSiblings?: boolean;
  md?: boolean;
  xl?: boolean;
  xxl?: boolean;
}>`
  display: flex;
  flex-direction: column;
  height: 80px;
  justify-content: space-around;
  ${props =>
    props.alignSiblings &&
    props.md === true &&
    props.xxl === false &&
    `
    > *:nth-child(1) {
      min-height: ${props.xl ? '47px' : '70px'};
    }
  `}
`;

export const StyledButton = styled(Button)`
  color: ${theme.gray8};
  > span:nth-of-type(2) {
    margin-left: 4px;
  }
`;

export const StyledLayout = styled.div<{ $mobile?: boolean }>`
  display: grid;
  grid-row-gap: 25px;
`;

export const StyledLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 30px;
`;
